/*eslint-disable sonarjs/cognitive-complexity*/
import React, { useCallback, useEffect, useState } from "react";

import { Checkbox, classNamesFunction, ComboBox, CommandBar, IComboBoxOption, ICommandBarItemProps, Label, Panel, PanelType, Persona, PersonaSize, Pivot, PivotItem, SearchBox, Separator, Spinner, SpinnerSize, Stack, StackItem, TextField, TooltipHost } from "@fluentui/react";

import { DashboardRoleId } from "../../../models/dashboardRoleId";
import { Feedback, FeedbackStatus, InfoFeedbackNer } from "../../../models/feedback";
import { IFeedbackNerPanelPropsStyles, IFeedbackNerPanelStyles, IFeedbackNerPanelProps, IFeedbackNerPanelComboBoxOption } from "./feedbackNerPanel.types";

import { dashboardApi } from "../../../services/dashboard.api";
import { useFeedbackList } from "../../../features/feedbackList";
import { useTranslation } from "react-i18next";
import { AnnotateBlendTag } from "../../../../common/components/annotator/types/annotate-types";
import TextAnnotate from "../../../../common/components/annotator/components/TextAnnotate";


const getClassNames = classNamesFunction<IFeedbackNerPanelPropsStyles, IFeedbackNerPanelStyles>();


export const FeedbackNerPanelBase = (props: IFeedbackNerPanelProps) => {
    const classNames = getClassNames(props.styles, { theme: props.theme, className: props.className });

    const feedbackList = useFeedbackList();
    const { t } = useTranslation(['common', 'dashboardFeedback', 'dashboardToolbar']);

    const { dismissPanel, feedbackId, isOpen } = props;

    const [allChecksSelected, setAllChecksSelected] = useState<boolean>(false);
    const [error, setError] = useState<boolean>(false);
    const [search, setSearch] = useState<string|undefined>("");    
    const [loading, setLoading] = useState<boolean>(false);
    const [searchCount, setSearchCount]= useState<number>(0);
    const [selectedElement, setselectedElement]= useState<number>(0);

    const [colors, setColors] = useState<IFeedbackNerPanelComboBoxOption[]>();
    const [feedback, setFeedback] = useState<Feedback>();
    const [infoFeedbackNer, setInfoFeedbackNer] = useState<InfoFeedbackNer>();
    const [nerTag, setNerTag] = useState<AnnotateBlendTag[]>([]);
    const [selectedCheckBoxes, setSelectedCheckBoxes] = useState<Record<string, boolean>>({});
    const [selectedCombo, setSelectedCombo] = useState<IComboBoxOption>();
    const colorConstant=[
        "#0000ff",
        "#007000",
        "#800000",
        "#800080",
        "#00BE00",
        "#EE0000",
        "#008080",
        "#d2691e",
        "#0000FF",
        "#4B0082",
        "#7B68EE",
        "#008C95"

        /*
        "#FF0000", // Rosso
        "#00FF00", // Verde
        "#0000FF", // Blu
        "#FF00FF", // Magenta
        "#00FFFF", // Ciano
        "#FFA500", // Arancione
        "#C9A0DC", // Glicine
        "#008000", // Verde scuro
        "#000080", // Blu scuro
        "#FFC0CB", // Rosa
        "#800000", // Marrone
        "#008080", // Verde bluastro
        "#800080", // Viola scuro
        "#808080", // Grigio
        "#C0C0C0", // Argento
        "#FFB500", // Arancio dorato
        "#FFCC00", // Arancione brillante
        */
       ];

       useEffect(()=>{
        const element = document.getElementById('idxMatch'+selectedElement);
        if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
       },[selectedElement])
        
    const [colorsList] = useState <string[]> (colorConstant);

    const generateColors = useCallback((metadataString?: string) => {

        if (!metadataString)
            return;

        const metadataJson = JSON.parse(metadataString);
        const checkBoxesDictionary: Record<string, boolean> = {};
        let feedbackNerPanelComboBoxOptions: IFeedbackNerPanelComboBoxOption[] = [];
        let colorIndex = 0;

        for (const propName in metadataJson) {

            const existingTag = nerTag.find(t => t.tag === propName);           

            // const randomColor = "#" + Math.floor(Math.random() * 16777215).toString(16);
            //const randomColor = Math.floor(Math.random() * colorsList.length);
            const feedbackNerPanelComboBoxOption: IFeedbackNerPanelComboBoxOption = {
                key: propName,
                text: propName,
                color: existingTag?.color ?? colorsList[colorIndex],
                value: metadataJson[propName]
            };
            feedbackNerPanelComboBoxOptions = feedbackNerPanelComboBoxOptions.concat(feedbackNerPanelComboBoxOption);
            checkBoxesDictionary[propName] = !!existingTag;

            colorIndex = (colorIndex+1)%colorsList.length;
        }

        setColors(feedbackNerPanelComboBoxOptions);
        setSelectedCheckBoxes(checkBoxesDictionary);
    }, [colorsList,nerTag]);


    useEffect(() => {

        // const tmp: Feedback = {
        //     id: 1,
        //     moduleInstanceId: 1,
        //     moduleInstanceName: "string",
        //     fileId: 3,
        //     fileName: "file pippo",
        //     entityId: 4,
        //     creatorName: "string",
        //     creatorEmail: "string",
        //     approverName: "string",
        //     approverEmail: "string",
        //     skillName: "skill pippo",
        //     metadataName: "string",
        //     oldValue: "string",
        //     newValue: "{\"part\":2, \"counterPart\":3, \"countries\":[\"Italia\", \"Germania\"], \"asd\":2, \"Data validità (formata: dd/mm/yyyy)\":2, \"asd4\":2, \"Durata del contrattata del contratto\":2, \"Test object\": [{\"test1\": \"testtest\", \"test2\": \"blabla\"}, {\"testAltroOggetto\": \"asdfghj\"}]}",
        //     elementContent: "string",
        //     fileContent: "contenuto del file  fdvifubvdfni fui fiuhfreauhg rei  feu fiufiue ghgre igreiuh gre iupgr gre grue giuer n rengrtj tn ti tuicontenuto del file fdvifubvdfni fui fiuhfreauhg rei  feu fiufiue ghgre igreiuh gre iupgr gre grue giuer n rengrtj tn ti tuicontenuto del file fdvifubvdfni fui fiuhfreauhg rei  feu fiufiue ghgre igreiuh gre iupgr gre grue giuer n rengrtj tn ti tuicontenuto del file fdvifubvdfni fui fiuhfreauhg rei  feu fiufiue ghgre igreiuh gre iupgr gre grue giuer n rengrtj tn ti tuicontenuto del file fdvifubvdfni fui fiuhfreauhg rei  feu fiufiue ghgre igreiuh gre iupgr gre grue giuer n rengrtj tn ti tuicontenuto del file fdvifubvdfni fui fiuhfreauhg rei  feu fiufiue ghgre igreiuh gre iupgr gre grue giuer n rengrtj tn ti tuicontenuto del file fdvifubvdfni fui fiuhfreauhg rei  feu fiufiue ghgre igreiuh gre iupgr gre grue giuer n rengrtj tn ti tui fdvifubvdfni fui fiuhfreauhg rei  feu fiufiue ghgre igreiuh gre iupgr gre grue giuer n rengrtj tn ti tuicontenuto del file fdvifubvdfni fui fiuhfreauhg rei  feu fiufiue ghgre igreiuh gre iupgr gre grue giuer n rengrtj tn ti tuicontenuto del file fdvifubvdfni fui fiuhfreauhg rei  feu fiufiue ghgre igreiuh gre iupgr gre grue giuer n rengrtj tn ti tuicontenuto del file fdvifubvdfni fui fiuhfreauhg rei  feu fiufiue ghgre igreiuh gre iupgr gre grue giuer n rengrtj tn ti tuicontenuto del file fdvifubvdfni fui fiuhfreauhg rei  feu fiufiue ghgre igreiuh gre iupgr gre grue giuer n rengrtj tn ti tuicontenuto del file fdvifubvdfni fui fiuhfreauhg rei  feu fiufiue ghgre igreiuh gre iupgr gre grue giuer n rengrtj tn ti tuicontenuto del file fdvifubvdfni fui fiuhfreauhg rei  feu fiufiue ghgre igreiuh gre iupgr gre grue giuer n rengrtj tn ti tui fdvifubvdfni fui fiuhfreauhg rei  feu fiufiue ghgre igreiuh gre iupgr gre grue giuer n rengrtj tn ti tuicontenuto del file fdvifubvdfni fui fiuhfreauhg rei  feu fiufiue ghgre igreiuh gre iupgr gre grue giuer n rengrtj tn ti tuicontenuto del file fdvifubvdfni fui fiuhfreauhg rei  feu fiufiue ghgre igreiuh gre iupgr gre grue giuer n rengrtj tn ti tuicontenuto del file fdvifubvdfni fui fiuhfreauhg rei  feu fiufiue ghgre igreiuh gre iupgr gre grue giuer n rengrtj tn ti tuicontenuto del file fdvifubvdfni fui fiuhfreauhg rei  feu fiufiue ghgre igreiuh gre iupgr gre grue giuer n rengrtj tn ti tuicontenuto del file fdvifubvdfni fui fiuhfreauhg rei  feu fiufiue ghgre igreiuh gre iupgr gre grue giuer n rengrtj tn ti tuicontenuto del file fdvifubvdfni fui fiuhfreauhg rei  feu fiufiue ghgre igreiuh gre iupgr gre grue giuer n rengrtj tn ti tui fdvifubvdfni fui fiuhfreauhg rei  feu fiufiue ghgre igreiuh gre iupgr gre grue giuer n rengrtj tn ti tuicontenuto del file fdvifubvdfni fui fiuhfreauhg rei  feu fiufiue ghgre igreiuh gre iupgr gre grue giuer n rengrtj tn ti tuicontenuto del file fdvifubvdfni fui fiuhfreauhg rei  feu fiufiue ghgre igreiuh gre iupgr gre grue giuer n rengrtj tn ti tuicontenuto del file fdvifubvdfni fui fiuhfreauhg rei  feu fiufiue ghgre igreiuh gre iupgr gre grue giuer n rengrtj tn ti tuicontenuto del file fdvifubvdfni fui fiuhfreauhg rei  feu fiufiue ghgre igreiuh gre iupgr gre grue giuer n rengrtj tn ti tuicontenuto del file fdvifubvdfni fui fiuhfreauhg rei  feu fiufiue ghgre igreiuh gre iupgr gre grue giuer n rengrtj tn ti tuicontenuto del file fdvifubvdfni fui fiuhfreauhg rei  feu fiufiue ghgre igreiuh gre iupgr gre grue giuer n rengrtj tn ti tui fdvifubvdfni fui fiuhfreauhg rei  feu fiufiue ghgre igreiuh gre iupgr gre grue giuer n rengrtj tn ti tuicontenuto del file fdvifubvdfni fui fiuhfreauhg rei  feu fiufiue ghgre igreiuh gre iupgr gre grue giuer n rengrtj tn ti tuicontenuto del file fdvifubvdfni fui fiuhfreauhg rei  feu fiufiue ghgre igreiuh gre iupgr gre grue giuer n rengrtj tn ti tuicontenuto del file fdvifubvdfni fui fiuhfreauhg rei  feu fiufiue ghgre igreiuh gre iupgr gre grue giuer n rengrtj tn ti tuicontenuto del file fdvifubvdfni fui fiuhfreauhg rei  feu fiufiue ghgre igreiuh gre iupgr gre grue giuer n rengrtj tn ti tuicontenuto del file fdvifubvdfni fui fiuhfreauhg rei  feu fiufiue ghgre igreiuh gre iupgr gre grue giuer n rengrtj tn ti tuicontenuto del file fdvifubvdfni fui fiuhfreauhg rei  feu fiufiue ghgre igreiuh gre iupgr gre grue giuer n rengrtj tn ti tui fdvifubvdfni fui fiuhfreauhg rei  feu fiufiue ghgre igreiuh gre iupgr gre grue giuer n rengrtj tn ti tuicontenuto del file fdvifubvdfni fui fiuhfreauhg rei  feu fiufiue ghgre igreiuh gre iupgr gre grue giuer n rengrtj tn ti tuicontenuto del file fdvifubvdfni fui fiuhfreauhg rei  feu fiufiue ghgre igreiuh gre iupgr gre grue giuer n rengrtj tn ti tuicontenuto del file fdvifubvdfni fui fiuhfreauhg rei  feu fiufiue ghgre igreiuh gre iupgr gre grue giuer n rengrtj tn ti tuicontenuto del file fdvifubvdfni fui fiuhfreauhg rei  feu fiufiue ghgre igreiuh gre iupgr gre grue giuer n rengrtj tn ti tuicontenuto del file fdvifubvdfni fui fiuhfreauhg rei  feu fiufiue ghgre igreiuh gre iupgr gre grue giuer n rengrtj tn ti tuicontenuto del file fdvifubvdfni fui fiuhfreauhg rei  feu fiufiue ghgre igreiuh gre iupgr gre grue giuer n rengrtj tn ti tui fdvifubvdfni fui fiuhfreauhg rei  feu fiufiue ghgre igreiuh gre iupgr gre grue giuer n rengrtj tn ti tuicontenuto del file fdvifubvdfni fui fiuhfreauhg rei  feu fiufiue ghgre igreiuh gre iupgr gre grue giuer n rengrtj tn ti tuicontenuto del file fdvifubvdfni fui fiuhfreauhg rei  feu fiufiue ghgre igreiuh gre iupgr gre grue giuer n rengrtj tn ti tuicontenuto del file fdvifubvdfni fui fiuhfreauhg rei  feu fiufiue ghgre igreiuh gre iupgr gre grue giuer n rengrtj tn ti tuicontenuto del file fdvifubvdfni fui fiuhfreauhg rei  feu fiufiue ghgre igreiuh gre iupgr gre grue giuer n rengrtj tn ti tuicontenuto del file fdvifubvdfni fui fiuhfreauhg rei  feu fiufiue ghgre igreiuh gre iupgr gre grue giuer n rengrtj tn ti tuicontenuto del file fdvifubvdfni fui fiuhfreauhg rei  feu fiufiue ghgre igreiuh gre iupgr gre grue giuer n rengrtj tn ti tui",
        //     createdOn: "string",
        //     updatedOn: "string",
        //     feedbackStatus: FeedbackStatus.Pending,
        //     feedbackType: 1,
        //     nerTaggedData: '[{"start": 0,"end": 18,"text": "contenuto del file","tag": "part","color": "#ab2d68"},{"start": 20,"end": 37,"text": "fdvifubvdfni fui ","tag": "counterPart","color": "#38597"}]',
        //     nerTaggedDataMappingDisplayName: '{"part": "Parte", "counterPart": "Controparte", "countries": "Paesi", "testObject": "Test object", "countries1": "Paesi", "countries2": "Paesi", "countries3": "Paesi"}'
        // };

        // setFeedback(tmp);
        // setNerTag(JSON.parse(tmp.nerTaggedData ?? '') as Array<AnnotateBlendTag>);

        // const tmp2: InfoFeedbackNer = {
        //     metadataModified: [
        //         {
        //             id: 0,
        //             moduleInstanceId: 0,
        //             moduleInstanceName: "null",
        //             fileId: 0,
        //             fileName: "null",
        //             entityId: 0,
        //             creatorName: "Francesco Valente1",
        //             creatorEmail: "Francesco.Valente@external.eni.com",
        //             approverName: "null",
        //             approverEmail: "null",
        //             skillName: "null",
        //             metadataName: "branch",
        //             oldValue: "[\"www\", \"w2\"]",
        //             newValue: "[\"fre\"]",
        //             feedbackStatus: 0,
        //             feedbackType: 0,
        //             createdOn: "26/04/2023 17:08:51",
        //             updatedOn: "null",
        //             elementContent: "null",
        //             fileContent: "null"
        //         },
        //         {
        //             id: 1,
        //             moduleInstanceId: 0,
        //             moduleInstanceName: "null",
        //             fileId: 0,
        //             fileName: "null",
        //             entityId: 0,
        //             creatorName: "Francesco Valente",
        //             creatorEmail: "Francesco.Valente@external.eni.com3",
        //             approverName: "null",
        //             approverEmail: "null",
        //             skillName: "null",
        //             metadataName: "branch",
        //             oldValue: "\"w2\"",
        //             newValue: "\"fre2\"",
        //             feedbackStatus: 0,
        //             feedbackType: 0,
        //             createdOn: "26/04/2023 17:08:50",
        //             updatedOn: "null",
        //             elementContent: "null",
        //             fileContent: "null"
        //         }
        //     ],
        //     metadataNotModified: [{
        //         id: 0,
        //         moduleInstanceId: 0,
        //         moduleInstanceName: "null",
        //         fileId: 0,
        //         fileName: "null",
        //         entityId: 0,
        //         creatorName: "Francesco Valente",
        //         creatorEmail: "Francesco.Valente@external.eni.com",
        //         approverName: "null",
        //         approverEmail: "null",
        //         skillName: "null",
        //         metadataName: "branch",
        //         oldValue: "",
        //         newValue: "[\"fre2\",\"fre2\"]",
        //         feedbackStatus: 0,
        //         feedbackType: 0,
        //         createdOn: "26/04/2023 17:08:50",
        //         updatedOn: "null",
        //         elementContent: "null",
        //         fileContent: "null"
        //     }],
        // };

        // setInfoFeedbackNer(tmp2);

        if (feedbackId) {

            setError(false);
            setLoading(true);

            dashboardApi.getElementDetails(feedbackId)
                .then((feedback) => {

                    setFeedback(feedback);
                    setNerTag(JSON.parse(feedback?.nerTaggedData ?? '[]') as Array<AnnotateBlendTag>);

                    dashboardApi.getInfoFeedbackNer(feedback.id).then((infoFeedback) => {
                        setInfoFeedbackNer(infoFeedback);
                    })
                        .catch((e) => {
                            setError(true);
                        }).finally(() => {
                            setLoading(false);
                        });
                })
                .catch((e) => {
                    setError(true);
                }).finally(() => {
                    setLoading(false);
                });
        }

    }, [feedbackId]);

    useEffect(() => {

        if (!colors)
            generateColors(feedback?.newValue);

        if (!selectedCombo && colors)
            setSelectedCombo(colors[0]);

        setAllChecksSelected(Object.values(selectedCheckBoxes).every(value => value));
    }, [colors, feedback, generateColors, selectedCombo, selectedCheckBoxes])

    const updateFeedbackStatus = useCallback((status: FeedbackStatus) => {

        setLoading(true);

        if (feedbackId) {
            dashboardApi.updateFeedback([feedbackId], status, JSON.stringify(nerTag))
                .then(() => {
                    dashboardApi.getInfoFeedbackNer(feedbackId)
                        .then((infoFeedback) => {
                            setInfoFeedbackNer(infoFeedback);
                        })
                        .catch((e) => {
                            console.log(e);
                        })
                    dismissPanel();
                })
                .catch((e) => {
                    console.log(e);
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }, [dismissPanel, feedbackId, nerTag]);

    const approveFeedbackAction = useCallback((): ICommandBarItemProps => ({
        key: "approveFeedback",
        text: t('dashboardToolbar:actions.approveFeedback'),
        iconProps: { iconName: "StatusCircleCheckmark", style: { fontSize: 20 } },
        onClick: () => {
            updateFeedbackStatus(FeedbackStatus.Approved);
        },
        disabled: !allChecksSelected ||
            (feedback?.feedbackStatus !== FeedbackStatus.Pending &&
                feedback?.feedbackStatus !== FeedbackStatus.Rejected),
    }), [t, allChecksSelected, feedback?.feedbackStatus, updateFeedbackStatus]);

    const approveFeedbackForDatasetAction = useCallback((): ICommandBarItemProps => ({
        key: "approveFeedbackForDataset",
        text: t('dashboardToolbar:actions.approveFeedbackForDataset'),
        iconProps: { iconName: "StatusCircleCheckmark", style: { fontSize: 20 } },
        onClick: () => {
            updateFeedbackStatus(FeedbackStatus.ReadyForDataset);
        },
        disabled: !allChecksSelected || feedback?.feedbackStatus === FeedbackStatus.DatasetCreated
    }), [t, allChecksSelected, feedback?.feedbackStatus, updateFeedbackStatus]);

    const rejectFeedbackAction = useCallback((): ICommandBarItemProps => ({
        key: "rejectFeedback",
        text: t('dashboardToolbar:actions.rejectFeedback'),
        iconProps: { iconName: "StatusCircleErrorX", style: { fontSize: 20 } },
        onClick: () => {
            updateFeedbackStatus(FeedbackStatus.Rejected);
        }
    }), [t, updateFeedbackStatus]);

    const actions = useCallback((): ICommandBarItemProps[] => {
        const acts = [] as ICommandBarItemProps[];

        if (feedbackList.currentDashboardRoleId === DashboardRoleId.DataScientist)
            acts.push(approveFeedbackForDatasetAction());
        else
            acts.push(approveFeedbackAction());

        acts.push(rejectFeedbackAction());

        return acts;
    }, [feedbackList.currentDashboardRoleId, approveFeedbackAction, approveFeedbackForDatasetAction, rejectFeedbackAction]);

    const onChangeCheckBox = React.useCallback(
        (ev?: React.FormEvent<HTMLElement | HTMLInputElement>, checked?: boolean, key?: string): void => {
            const selectedChecks = { ...selectedCheckBoxes };

            if (key) {
                selectedChecks[key] = !!checked;
                setSelectedCheckBoxes(selectedChecks);
            }
        },
        [selectedCheckBoxes],
    );

    const onRenderFooterContent = React.useCallback(() =>
        <CommandBar items={actions()} />,
        [actions]
    );


    const dismissPanelAndResetState = () => {
        setColors(undefined);
        setFeedback(undefined);
        setInfoFeedbackNer(undefined);
        setNerTag([]);
        setSelectedCheckBoxes({});

        dismissPanel();
    }

    const renderData = (metadata: string) => {
        const metadataJson = JSON.parse(metadata);

        if (Array.isArray(metadataJson)) {
            return <>
                {
                    metadataJson.map((value, id) => {

                        if (typeof value === 'object') {

                            const elements: JSX.Element[] = [];

                            Object.entries(value).forEach(([key, value]) => {

                                elements.push(<Label
                                    style={{ fontWeight: 'normal' }}
                                    key={`Label_${key}_${id}`}
                                >
                                    {key}
                                </Label>);

                                elements.push(<TextField
                                    style={{}}
                                    key={`TextField_${value}_${id}`}
                                    value={`${value}`}
                                    disabled
                                    readOnly
                                />);
                            });

                            return elements;
                        }

                        else return <TextField
                            key={`TextField_${value}_${id}`}
                            value={value}
                            disabled
                            readOnly
                        />
                    })
                }
            </>
        }
        else
            return <TextField disabled readOnly value={metadataJson} />
    }

    const GenerateMetadata = () => {
        return colors?.map((item, i) => {

            if (Array.isArray(item.value)) {
                return <>
                    <Label>{item.text}</Label>
                    {
                        item.value.length ?
                            item.value.map((value, index) => {

                                const elements: JSX.Element[] = [];

                                if (typeof value === 'object') {
                                    Object.entries(value).forEach(([key, value]) => {

                                        elements.push(<Label
                                            style={{ marginLeft: '10px', fontWeight: 'normal' }}
                                            key={`TextField_${key}_${index}`}>
                                            {key}
                                        </Label>);

                                        elements.push(<TextField
                                            styles={{
                                                root: {
                                                    paddingLeft: '10px'
                                                }
                                            }}
                                            key={`TextField_${value}_${index}`}
                                            value={`${value}`}
                                            disabled
                                            readOnly
                                        />);
                                    });

                                    return elements;
                                }

                                else return <TextField
                                    key={`TextField_${item.key}_${value}_${index}`}
                                    value={value}
                                    disabled
                                    readOnly
                                />
                            })
                            : <TextField disabled readOnly />
                    }
                </>
            }
            else
                return <>
                    <Label>{item.text}</Label>
                    <TextField disabled readOnly value={item.value} />
                </>
        })
    }
    function formatDateToLocalTime(updatedOn: string | undefined) {
        if (updatedOn !== null && updatedOn !== undefined && updatedOn !== " ") {
            const dateToConvert = new Date(updatedOn);
            updatedOn = `${dateToConvert.toLocaleDateString()} ${dateToConvert.toLocaleTimeString()}`;
        }

        return updatedOn;
    }
    const GenerateInfoFeedback = () =>
        <Stack style={{ marginTop: "20px" }}>
            <StackItem>
                <Separator alignContent="start">{t('dashboardFeedback:ner.changed')}</Separator>

                {
                    infoFeedbackNer?.metadataModified.map((elem, key) => {
                        if (elem.updatedOn != null && elem.updatedOn !== " ") {
                            const dateToConvert = new Date(elem.updatedOn);
                            elem.updatedOn = `${dateToConvert.toLocaleDateString()} ${dateToConvert.toLocaleTimeString()}`;
                        }

                        return (
                            <Stack horizontal key={`FeedbackInfo_${elem.id}`}>
                                <StackItem style={{ margin: '10px', padding: '10px', width: "28%" }}>
                                    <Label>{elem.metadataName} {t('dashboardFeedback:ner.datonuovo')}</Label>
                                    {renderData(elem.newValue)}
                                </StackItem>
                                <StackItem style={{ margin: '10px', padding: '10px', width: "31%" }}>
                                    <Label>{elem.metadataName} {t('dashboardFeedback:ner.datoold')}</Label>
                                    {renderData(elem.oldValue)}
                                </StackItem>
                                <StackItem style={{ margin: '10px', padding: '10px', width: "10%" }}>
                                    <Label>{t('dashboardFeedback:ner.updatedBy')}</Label>
                                    <div className={classNames.personaCell}>
                                        <TooltipHost content={`${elem.creatorName} (${elem.creatorEmail})`} >
                                            <Persona text={elem.creatorName} size={PersonaSize.size24} hidePersonaDetails={true} />
                                        </TooltipHost>
                                    </div>
                                </StackItem>
                                <StackItem style={{ margin: '10px', padding: '10px', width: "31%" }}>
                                    <Label>{t('dashboardFeedback:ner.updatedOn')}</Label>
                                    <TextField disabled readOnly value={formatDateToLocalTime(elem.createdOn)} />
                                </StackItem>
                            </Stack>
                        )
                    })}
            </StackItem>
            <StackItem>
                <Separator alignContent="start">{t('dashboardFeedback:ner.notChanged')}</Separator>
                {infoFeedbackNer?.metadataNotModified.map((elem, key) => {
                    return <StackItem
                        key={`StackItem_FeedbackNer_${key}`}
                        style={{ margin: '10px', padding: '10px', width: "31%" }}>

                        <Label>{elem.metadataName}</Label>
                        {renderData(elem.newValue)}
                    </StackItem>
                })}


            </StackItem>
        </Stack>

    return (
        <Panel
            closeButtonAriaLabel="Close" // You MUST provide this prop! Otherwise screen readers will just say "button" with no label.
            headerText={t('dashboardFeedback:ner.dettaglioFeedback')}
            onDismiss={dismissPanelAndResetState}
            onRenderFooterContent={onRenderFooterContent}
            type={PanelType.large}
            isOpen={isOpen}
            styles={{
                scrollableContent: {
                    height: '100%'
                }
            }}
        >
            {loading ?
                <div className={classNames.loadingErrorContainer}>
                    <Spinner size={SpinnerSize.large} />
                </div>
                :
                error ?
                    <span>{' something went wrong :( '}</span>
                    :
                    <Pivot className={classNames.pivot}>

                        <PivotItem headerText={t('dashboardFeedback:ner.retagging')}>

                            <Stack horizontal style={{ marginTop: '20px' }}>

                                <Stack.Item style={{ width: '70%' }}>
                                    <Stack>

                                        <Stack.Item style={{ border: '2px solid gray', margin: '10px', padding: '10px' }}>
                                            <Stack horizontal tokens={{ childrenGap: 10 }} style={{ overflowX: 'auto' }}>
                                                {
                                                    colors?.map((item, _) =>
                                                        <Stack.Item key={`StackItem_${item.key}`} style={{ marginBottom: '10px' }}>
                                                            <TooltipHost content={item.text}>
                                                                <Checkbox
                                                                    checked={selectedCheckBoxes[item.key]}
                                                                    key={`CheckBox_${item.key}`}
                                                                    label={item.text}
                                                                    onChange={(ev, checked) =>
                                                                        onChangeCheckBox(ev, checked, item.key as string)}
                                                                    styles={{
                                                                        text: {
                                                                            color: item.color,
                                                                            whiteSpace: 'nowrap',
                                                                            overflow: "hidden",
                                                                            textOverflow: "ellipsis",
                                                                            maxWidth: '140px'
                                                                        }
                                                                    }}
                                                                />
                                                            </TooltipHost>
                                                        </Stack.Item>
                                                    )
                                                }

                                            </Stack>

                                        </Stack.Item>

                                        <Stack.Item className={classNames.content}>

                                            <Stack horizontal style={{ marginTop: '20px' }} horizontalAlign="space-between">
                                                <Stack.Item>
                                                    <ComboBox
                                                        style={{ width: '200px' }}
                                                        defaultSelectedKey={colors ? colors[0].key : null}
                                                        options={colors as IComboBoxOption[]}
                                                        onChange={(_, option) => { setSelectedCombo(option) }}
                                                    />
                                                </Stack.Item>
                                                <Stack.Item>
                                                    <div  style={{ display: 'flex' }}>
                                                        <SearchBox style={{ width: '200px' }}    
                                                            placeholder={t('dashboardFeedback:search')}
                                                            onClear={ev => { setSearch(undefined); setselectedElement(0)}}
                                                            onSearch={(newValue) => {  setSearch(newValue); setselectedElement( (searchCount!==0?((selectedElement)%searchCount +1):0)) }}
                                                            />    
                                                                                                       
                                                    </div>
                                                    <div style={{ marginTop: '5px' }}>
                                                    {   (search !== undefined && search !== "" ?  
                                                        ""+(searchCount!==0?selectedElement:0)        + "/"+                                                  
                                                         searchCount+ " " + t('dashboardFeedback:findResult') : "")                                                        
                                                    }
                                                    </div> 
                                                </Stack.Item>
                                            </Stack>


                                            <TextAnnotate
                                                totalCount={(c) => setSearchCount(c)}
                                                style={{
                                                    fontSize: '1.7rem',
                                                    height: '50vh',
                                                    marginTop: '20px',
                                                    overflowY: 'auto'
                                                }}
                                                content={feedback?.fileContent ?? ""}
                                                search = {search}                                               
                                                onChange={(value) => {

                                                    if (feedback?.feedbackStatus !== FeedbackStatus.Pending &&
                                                        feedback?.feedbackStatus !== FeedbackStatus.Rejected) {
                                                        setNerTag(nerTag);
                                                        return;
                                                    }

                                                    const key = selectedCombo ? selectedCombo?.key as string :
                                                        colors ? colors[0].key : '';
                                                    const selectedChecks = { ...selectedCheckBoxes };

                                                    selectedChecks[key] = true;
                                                    setNerTag(value);
                                                    setSelectedCheckBoxes(selectedChecks);
                                                }}
                                                value={nerTag}
                                                selectedElement={selectedElement}
                                                getSpan={(span) => ({
                                                    ...span,
                                                    tag: selectedCombo?.key as string ?? '',
                                                    color: (selectedCombo as IFeedbackNerPanelComboBoxOption)?.color,
                                                })}
                                            />

                                        </Stack.Item>
                                    </Stack>
                                </Stack.Item>

                                <Stack.Item style={{ margin: '0 20px' }}>
                                    <Separator styles={{
                                        root: {
                                            display: 'inline-block',
                                            height: '100%'
                                        }
                                    }} vertical />
                                </Stack.Item>


                                <Stack.Item style={{ width: '30%' }}>
                                    <Label>{t('dashboardFeedback:ner.fileName')}</Label>
                                    <TextField disabled readOnly value={feedback?.fileName} />

                                    <Label>{t('dashboardFeedback:ner.skill')}</Label>
                                    <TextField disabled readOnly value={feedback?.skillName} />

                                    <Separator alignContent="start">{t('dashboardFeedback:ner.metadata')}</Separator>

                                    <Stack>
                                        <Stack.Item style={{ overflowY: 'auto' }}>
                                            {GenerateMetadata()}
                                        </Stack.Item>
                                    </Stack>

                                </Stack.Item>
                            </Stack>

                        </PivotItem>

                        <PivotItem headerText={t('dashboardFeedback:ner.infoFeedback')}>
                            {GenerateInfoFeedback()}
                        </PivotItem>

                    </Pivot>
            }
        </Panel >
    );
}
